import { Directive } from '@angular/core';
@Directive({
  selector: '[miqStopClick]',
  host: {
    '(click)': 'onClick($event)',
    '(keydown)': 'onKeyDown($event)',
  },
})
export class StopClickDirective {
  onClick(e) {
    e.stopPropagation();
  }
  onKeyDown(e) {
    if (e.keyCode === 32) {
      e.stopPropagation();
    }
  }
}
